import Vue from 'vue'
import Vuex from 'vuex'
import { CanalDeVendasResource } from '@/resources/CanalDeVenda.resource.js'

Vue.use(Vuex)

export default {
  state : {
    saleChannel: []
  },
  mutations: {
    setSaleChannel(state, saleChannel) {
      state.saleChannel = saleChannel
    },
  },
  actions: {
    saleChannel : ({commit, state}) => {
      return new Promise((resolve, reject) => {
        if (state.saleChannel.length <= 0) {
          CanalDeVendasResource.getLista().then((response) => {
            if (response.data.isSuccess) {
              commit('setSaleChannel', response.data.payload.items);
              resolve(response.data.payload);
            } else {
              reject();
            }
          })
          .catch((e) => {
            reject();
          })
        } else {
          resolve(state.saleChannel);
        }
      });
    }
  },
  getters: {
    getSaleChannel: (state) => {
      return state.saleChannel 
    }
  },
}
